export default __webpack_public_path__ + "static/media/bi.a43d3b12.png";